import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  path: string;
}>;

export function ShortLink({ children, path }: Props) {
  return (
    <a href={`https://apps.appf.re/${path}`} target="_blank" rel="noreferrer noopener">
      {children}
    </a>
  );
}
